export const i18nGlossary = {
  action_buttons: {
    edit: 'Editar',
    delete: 'Deletar',
    save: 'Salvar',
    cancel: 'Cancelar',
    close: 'Fechar',
  },
  all: {
    all: 'Todos',
    all_male: 'Todos',
    all_female: 'Todas',
  },
  alarm: {
    alarm: 'alarme',
    alarm_one: 'alarme',
    alarm_other: 'alarmes',
  },
  asset: {
    asset: 'equipamento',
    asset_one: 'equipamento',
    asset_other: 'equipamentos',
  },
  sensor: {
    sensor: 'sensor',
    sensor_one: 'sensor',
    sensor_other: 'sensores',
  },
  vessel: {
    vessel: 'navio',
    vessel_one: 'navio',
    vessel_other: 'navios',
  },
  category: {
    category: 'categoria',
    category_one: 'categoria',
    category_other: 'categorias',
  },
  error: {
    title: 'Desculpe o transtorno',
    message: 'Ocorreu um erro inesperado. Por favor, tente novamente.',
  },
  yes: 'sim',
  no: 'não',
  search: 'Pesquisar',
  tryAgain: 'Tente novamente',
  system_name: 'Nome de sistema',
  screen_name: 'Nome de visualização',
  alarm_id: 'ID do alarme',
  home: 'Inicial',
  users_and_permissions: 'Usuários e permissões',
  tags: 'Tags',
  risk_score: 'Pontuação de risco',
  file: { file: 'arquivo', file_one: 'arquivo', file_other: 'arquivos' },
  attachment: { attachment: 'anexo', attachment_one: 'anexo', attachment_other: 'anexos' },
  comment: { comment: 'comentário', comment_one: 'comentário', comment_other: 'comentários' },
};
